import { readCookie } from "./js/readCookie";

window.googletag = window.googletag || { cmd: [] };

window.htAdsJSON = {
  adUnitSlots: {
    adUnitSlotsDesktopPostRegular: {},
  },
  prebidAdUnits: {
    prebidAdUnitsDesktopPostRegular: {},
  },
  pageKeyValues: window.adsJSON.pageLevelKVTargeting,
};

googletag.cmd.push(() => {
  // Size Mapping
  const sizeMappingSetting = window.adsJSON.sizeMappings;
  Object.keys(sizeMappingSetting).forEach((sizeName) => {
    const sizeData = sizeMappingSetting[sizeName];

    const googletagsize = googletag.sizeMapping();
    Object.keys(sizeData).forEach((breakpoint) => {
      const size = sizeData[breakpoint];
      // eslint-disable-next-line no-eval
      googletagsize.addSize(JSON.parse(breakpoint), eval(size));
    }); // end foreachsize dat

    window[sizeName] = googletagsize.build();
  }); // end foreach size map
});

// Grab the appropriate prebid map (determined by BE based off of the vertical)
window.htPrebidMap = window.adsJSON.prebidMap;

const BILLBOARD_AD_SLOT_NAME = "Billboard-b";
const HOMEPAGE_BILLBOARD_AD_SLOT_NAME = "Homepage_Billboard-b";
const WHATS_NEW_BILLBOARD_AD_SLOT_NAME = "WhatsNew_Billboard-b";
const billboardMapping = {
  california_index_view: HOMEPAGE_BILLBOARD_AD_SLOT_NAME,
  forum_list: BILLBOARD_AD_SLOT_NAME,
  whats_new: WHATS_NEW_BILLBOARD_AD_SLOT_NAME,
  whats_new_posts: WHATS_NEW_BILLBOARD_AD_SLOT_NAME,
  whats_new_looking_for_replies: WHATS_NEW_BILLBOARD_AD_SLOT_NAME,
  xa_sc_whats_new_items: WHATS_NEW_BILLBOARD_AD_SLOT_NAME,
  xfmg_whats_new_media: WHATS_NEW_BILLBOARD_AD_SLOT_NAME,
};

// Add front end handling of billboard behaviour
if (window.adConfig?.useEdgeCacheAds) {
  if (
    readCookie(`xf_${billboardMapping[window.adConfig.template]}`) !== "true"
  ) {
    window.adsJSON.adUnits = window.adsJSON.adUnits.filter(
      (obj) => obj.name !== "Desktop_Adhesion"
    );
    const date = new Date();
    const days = 1;
    const MILLISECONDS_PER_DAY = 24 * 60 * 60 * 1000;
    const expireTS = date.getTime() + days * MILLISECONDS_PER_DAY; // Milliseconds

    date.setTime(expireTS);
    const expires = `; expires=${date.toGMTString()}`;

    // create billboard cookie
    document.cookie = `xf_${billboardMapping[window.adConfig.template]}=true${expires}; path=/`;
  } else {
    window.adsJSON.adUnits = window.adsJSON.adUnits.filter(
      (obj) => obj.name !== billboardMapping[window.adConfig.template]
    );
  }
}

// foreach window.adsJSON
window.adsJSON.adUnits.forEach((slot) => {
  // build basic slot info
  window.htAdsJSON.adUnitSlots.adUnitSlotsDesktopPostRegular[slot.divId] = {
    unitPath: slot.adCode,
    sizes: slot.sizes,
    htmlId: slot.divId,
    platform: slot.platform,
    pageType: "ros",
    sizeMapping: slot.sizeMapping,
    keyValues: slot.kvTargeting,
  };

  const noPrebidorTAM = [
    "RightRail_Vendor",
    "Homepage_Billboard",
    "Billboard",
    "WhatsNew_Billboard",
    "In-Thread_Quotebox",
    "In-Thread_Quotebox_Mobile",
  ];

  if (noPrebidorTAM.includes(slot.name)) {
    window.htAdsJSON.adUnitSlots.adUnitSlotsDesktopPostRegular[
      slot.divId
    ].options = {
      requestBid: slot.requestBid ?? false,
      amazonBid: slot.amazonBid ?? false,
      no_refresh: slot.noRefresh ?? false,
      collapseEmpty: slot.collapseEmpty ?? false,
      collapseEmptyIfNotFilled: slot.collapseEmptyIfNotFilled ?? false,
    };
  } else {
    window.htAdsJSON.adUnitSlots.adUnitSlotsDesktopPostRegular[
      slot.divId
    ].options = {
      adBlockRender: slot.adBlockRender ?? false,
    };
  }
  if (slot.controlledBy === "browsi" && window.browsi) {
    window.htAdsJSON.adUnitSlots.adUnitSlotsDesktopPostRegular[
      slot.divId
    ].options.controlledBy = slot.controlledBy;
    window.htAdsJSON.adUnitSlots.adUnitSlotsDesktopPostRegular[
      slot.divId
    ].keyValues.AmazonTAM = "HT";
    window.htAdsJSON.adUnitSlots.adUnitSlotsDesktopPostRegular[
      slot.divId
    ].keyValues.PrebidTech = "BR";
  }

  if (!window.htPrebidMap[slot.name]) {
    return;
  }

  window.htAdsJSON.prebidAdUnits.prebidAdUnitsDesktopPostRegular[slot.adCode] =
    window.htPrebidMap[slot.name];
  const adagio = window.htAdsJSON.prebidAdUnits.prebidAdUnitsDesktopPostRegular[
    slot.adCode
  ].bids.find((el) => el.bidder === "adagio");
  if (adagio) {
    adagio.params.site = window.adConfig.adagioSite
      ? window.adConfig.adagioSite
      : window.location.hostname.replace("www.", "").replace(/\./g, "-");
  }
}); // end foreach window.adsJSON.adUnits slot
